// Derive a one-line plain-text preview of a text note's HTML body, shown in the
// documents list "Opis" column (same treatment files get from `description`).
export function textNotePreview(content: string | undefined | null): string {
  if (!content) return '';
  return content
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
